import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import React, { useCallback, useEffect, useState, } from 'react';
import { Keyboard, KeyboardAvoidingView as RNKeyboardAvoidingView, Platform, } from 'react-native';
import { KeyboardAvoidingView as KCKeyboardAvoidingView } from 'react-native-keyboard-controller';
// On iOS, React Native's version animates with LayoutAnimation, which the New
// Architecture runs on a linear curve, so the content lags behind the keyboard.
// keyboard-controller's version follows the keyboard frame by frame.
const OriginalKeyboardAvoidingView = Platform.OS === 'ios' ? KCKeyboardAvoidingView : RNKeyboardAvoidingView;
const useIsFloatingKeyboard = () => {
    const [isFloating, setFloating] = useState(false);
    const { deviceWidth: width } = useAppFrameDimensions();
    const onKeyboardWillChangeFrame = useCallback((event) => {
        setFloating(event.endCoordinates.width !== width);
    }, [width]);
    useEffect(() => {
        const listener = Keyboard.addListener('keyboardWillChangeFrame', onKeyboardWillChangeFrame);
        return () => {
            listener.remove();
        };
    }, [onKeyboardWillChangeFrame]);
    return isFloating;
};
const KeyboardAvoidingView = ({ children, ...props }) => {
    const isFloatingKeyboard = useIsFloatingKeyboard();
    return (<OriginalKeyboardAvoidingView {...props} enabled={isFloatingKeyboard ? false : props.enabled}>
      {children}
    </OriginalKeyboardAvoidingView>);
};
export default KeyboardAvoidingView;
